import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TramRegistroService } from '../../../services/database/tramRegistro.service';
import { TranslateService } from '@ngx-translate/core';
import { IGetDashboardDetalleActividades, IGetTramiteRegistroSeleccionFechas } from '../../../shared/interfaces/database/tramite';
import { FilterDialogComponent } from '../../../components/custom-work/other/filter-dialog/filter-dialog.component';
import { CommonModule } from '@angular/common';
import { firstValueFrom, forkJoin } from 'rxjs';
import { ButtonModule } from 'primeng/button';
import { CustomTableHeader, CustomTitle, DATE_WITH_HOUR_FORMAT, IColumns,Utils } from 'lib-base';
import { TableModule } from 'primeng/table';
import { SeguimientosHistorialComponent } from '../../configuracion/admin-actividad/tramite-historial/seguimientos-historial/seguimientos-historial.component';
import {TagModule} from "primeng/tag";

@Component({
  selector: 'app-detalle-actividades',
  standalone: true,
  imports: [CommonModule, FilterDialogComponent, ButtonModule, CustomTitle, TableModule, CustomTableHeader, SeguimientosHistorialComponent, TagModule],
  templateUrl: './detalle-actividades.component.html',
  styleUrl: './detalle-actividades.component.scss'
})
export class DetalleActividadesComponent implements OnInit {

  #tipoTramiteId !: number;
  #dependenciaId !: number;
  #secUsuarioId !: number;

  readonly defaultDateFormat = DATE_WITH_HOUR_FORMAT;
  translations: any = {};

  size: number = 7;
  isLoading: boolean = true;
  detalleActividades: IGetDashboardDetalleActividades[] = [];
  columns !: IColumns[];

  filtrarMesText !: string;
  private _seleccionFechas: IGetTramiteRegistroSeleccionFechas[] = [];
  private _selectedSeleccionFecha !: IGetTramiteRegistroSeleccionFechas | undefined;
  @ViewChild('filtrarMes') filtrarMesDialogComponent !: FilterDialogComponent<IGetTramiteRegistroSeleccionFechas>;

  constructor(private readonly _ar: ActivatedRoute, private readonly _tr: TramRegistroService, private readonly _t: TranslateService) {
    this.#tipoTramiteId = Number(this._ar.snapshot.params['tipoTramiteId']);
    this.#dependenciaId = Number(this._ar.snapshot.params['dependenciaId']);
    this.#secUsuarioId = Number(this._ar.snapshot.params['secUsuarioId']);
  }

  async ngOnInit() {
    this.translations = await firstValueFrom(forkJoin({
      filtrarMes: this._t.get('msg.filtrar-mes'),
      mes: this._t.get('common.mes'),
      titulo1: this._t.get('components.app-detalle-actividades.titulo1'),
      funcionario: this._t.get('common.funcionario'),
      fechaTramite: this._t.get('msg.fecha-tramite'),
      estado: this._t.get('common.estado'),
      tramite: this._t.get('common.tramite'),
      actividad: this._t.get('common.actividad'),
      fechaInicioProgramada: this._t.get('msg.fecha-inicio-programada'),
      fechaFinProgramada: this._t.get('msg.fecha-fin-programada'),
      fechaInicioEjecutada: this._t.get('msg.fecha-inicio-ejecutada'),
      fechaFinalReal: this._t.get('msg.fecha-final-real'),
      diasRetraso: this._t.get('msg.dias-retraso'),
      observaciones: this._t.get('common.observaciones'),
    }));
    this.columns = [
      {
        id: 'expand-column',
        field: '',
        header: '',
        sort: false,
        columnFilter: false,
        width: '5rem'
      },
      {
        id: 'tramite-column',
        field: 'tramite',
        header: this.translations.tramite,
        sort: true,
        class: 'text-left color-blue-2 font-13 font-bold',
        style: {'text-wrap': 'auto'},
        columnFilter: true,
        width: '12rem'
      },
      {
        id: 'actividad-column',
        field: 'actividad',
        header: this.translations.actividad,
        sort: true,
        class: 'text-left color-blue-2 font-13 font-bold',
        columnFilter: true,
        width: '13rem'
      },
      {
        id: 'fechaTramite-column',
        field: 'fechaTramite',
        header: this.translations.fechaTramite,
        sort: false,
        class: 'text-left color-blue-2 font-13 font-bold',
        style: {'text-wrap': 'auto'},
        columnFilter: false,
        width: '8rem'
      },
      {
        id: 'estado-column',
        field: 'estado',
        header: this.translations.estado,
        sort: true,
        class: 'text-left color-blue-2 font-13 font-bold',
        style: {'text-wrap': 'auto'},
        columnFilter: true,
        width: '10rem'
      },

      {
        id: 'fechaInicioProgramada-column',
        field: 'fechaInicioProgramada',
        header: this.translations.fechaInicioProgramada,
        sort: false,
        class: 'text-left color-blue-2 font-13 font-bold',
        style: {'text-wrap': 'auto'},
        columnFilter: false,
        width: '10rem'
      },
      {
        id: 'fechaFinProgramada-column',
        field: 'fechaFinProgramada',
        header: this.translations.fechaFinProgramada,
        sort: false,
        class: 'text-left color-blue-2 font-13 font-bold',
        style: {'text-wrap': 'auto'},
        columnFilter: false,
        width: '10rem'
      },
      {
        id: 'fechaInicioEjecutada-column',
        field: 'fechaInicioEjecutada',
        header: this.translations.fechaInicioEjecutada,
        sort: false,
        class: 'text-left color-blue-2 font-13 font-bold',
        style: {'text-wrap': 'auto'},
        columnFilter: false,
        width: '10rem'
      },
      {
        id: 'fechaFinalReal-column',
        field: 'fechaFinalReal',
        header: this.translations.fechaFinalReal,
        sort: false,
        class: 'text-left color-blue-2 font-13 font-bold',
        style: {'text-wrap': 'auto'},
        columnFilter: false,
        width: '10rem'
      },
      {
        id: 'diasRetraso-column',
        field: 'diasRetraso',
        header: this.translations.diasRetraso,
        sort: false,
        class: 'text-left color-blue-2 font-13 font-bold',
        style: {'text-wrap': 'auto'},
        columnFilter: false,
        width: '5rem'
      },
      {
        id: 'observaciones-column',
        field: 'observaciones',
        header: this.translations.observaciones,
        sort: false,
        class: 'text-left color-blue-2 font-13 font-bold',
        style: {'text-wrap': 'auto'},
        columnFilter: false,
        width: '10rem'
      },
    ]
    this.getDashboardDetalleActividades();
    this.getTramiteRegistroSeleccionFechas();
    this.filtrarMesText = this.translations.filtrarMes;
  }

  openFiltrarMesDialog() {
    this.filtrarMesDialogComponent.setHeaderText(this.translations.filtrarMes);
    this.filtrarMesDialogComponent.InitializeDropdownFilter('monthYear', this._seleccionFechas);
    this.filtrarMesDialogComponent.showDialog();
  }

  filtrarMesOnSeleccionar(id: IGetTramiteRegistroSeleccionFechas) {
    this._selectedSeleccionFecha = id;
    this.filtrarMesText = id ? this.translations.mes + ': ' + id.monthYear : this.translations.filtrarMes;
    this.getDashboardDetalleActividades();
  }
  getTramiteEstadoTagSeverity(estado: string): 'success' | 'secondary' | 'info' | 'warning' | 'danger' | 'contrast' {
    return Utils.getTramiteEstadoTagSeverity(estado, '');
  }

  //#region API calls
  getDashboardDetalleActividades() {
    this.isLoading = true;
    this._tr.getDashboardDetalleActividades(this.#tipoTramiteId, this.#dependenciaId, this.#secUsuarioId, this._selectedSeleccionFecha?.firstDayOfMonth).subscribe({
      next: (data: IGetDashboardDetalleActividades[]) => {
        this.detalleActividades = data;
      },complete: () => {
        this.isLoading = false;
      }
    });
  }

  getTramiteRegistroSeleccionFechas() {
    this._tr.getTramiteRegistroSeleccionFechas().subscribe({
      next: (data: IGetTramiteRegistroSeleccionFechas[]) => {
        this._seleccionFechas = data?.sort((a,b) => a.firstDayOfMonth > b.firstDayOfMonth ? -1 : 1);
      }
    })
  }
  //#endregion
}
